

export const comma = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// URL querystring 으로 흘러들어가면 Azure WAF CRS 3.2 의 921151 (newline in GET args) 등
// 여러 룰에 차단되는 문자들을 정규화한다.
// - \r\n\t\f\v 는 공백으로 치환 (단어 경계 보존)
// - 그 외 C0 제어문자 (NUL, BEL, BS, ESC 등) 와 DEL 은 완전히 제거
// - zero-width (ZWSP, ZWNJ, ZWJ, BOM) 도 제거
// - U+2028/U+2029 는 JS \s 에 포함되므로 마지막 연속공백 축약 단계에서 처리됨
export const sanitizeSearchInput = (input: string | null | undefined): string => {
  if (!input) return '';
  return input
    .replace(/[\r\n\t\f\v]+/g, ' ')
    .replace(/[\u0000-\u0008\u000E-\u001F\u007F]+/g, '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const strutil = {
   comma,
   sanitizeSearchInput,
};
